import React from 'react';
import './LevelGraph.scss';

const LEVEL_ACTIVE_COUNTS = {
  early: 1,
  developing: 2,
  'early-to-developing': 2,
  established: 3,
  advanced: 4,
};

function capitalizeFirstLetter(str) {
  if (typeof str !== 'string' || str.length === 0) {
    return str; // Handle non-string input or empty strings
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const LevelGraph = ({ level, variant, showLabel = true }) => {
  const activeCount = LEVEL_ACTIVE_COUNTS[level] || 0;

  return (
    <div
      className={`level-graph${variant ? ` level-graph--${variant.toLowerCase()}` : ''}${showLabel ? '' : ' level-graph--label-hidden'}`}
      data-level={level}
    >
      {showLabel && (
        <div className="level-graph__label">{capitalizeFirstLetter(level)}</div>
      )}
      <div className="level-graph__circles">
        {[0, 1, 2, 3].map((index) => (
          <div
            key={index}
            className={`level-graph__circle${index < activeCount ? ' is-active' : ''}`}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default LevelGraph;
